// SageTech Customer Web Portal — Design System
// Matches iOS SageTheme exactly — LIGHT theme (customer app)
// Pro app uses dark theme (#120B1E bg)

export const colors = {
  // Backgrounds
  background: '#F5F3F8',       // Soft lavender white (iOS Colors.background)
  surface: '#FFFFFF',           // Pure white cards (iOS Colors.surface)
  surfaceElevated: '#EDE9F4',  // Slightly tinted elevated surface

  // Brand
  primary: '#C026A0',           // Hot pink-purple (iOS Colors.primary)
  primaryLight: 'rgba(192,38,160,0.1)',
  accent: '#9333EA',            // Rich purple (iOS Colors.accent)
  pink: '#E040A0',
  gradientStart: '#E040A0',
  gradientEnd: '#7B2FBE',

  // Text
  textPrimary: '#1A0A2E',       // Deep purple-black (iOS Colors.textPrimary)
  textSecondary: '#6B5B8A',     // Muted purple-grey (iOS Colors.textSecondary)
  textTertiary: '#A090BC',

  // Status
  success: '#2ECC71',
  error: '#E74C3C',
  warning: '#F39C12',
  gold: '#FFD700',

  // UI
  divider: 'rgba(26,10,46,0.08)',
  shadow: 'rgba(26,10,46,0.08)',
  border: 'rgba(26,10,46,0.1)',

  // Orange accent (CTA / emergency)
  orange: '#FF8C00',
};

export const gradients = {
  primary: `linear-gradient(135deg, ${colors.gradientStart}, ${colors.gradientEnd})`,
  button: `linear-gradient(135deg, ${colors.gradientStart} 0%, ${colors.gradientEnd} 100%)`,
  card: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})`,
};

export const radius = {
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  pill: 999,
};

export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
};

export const tierColors: Record<string, string> = {
  diamond: '#00D4FF',
  gold: '#FFD700',
  silver: '#C0C0C0',
  bronze: '#CD7F32',
};

export const tierEmoji: Record<string, string> = {
  diamond: '💎',
  gold: '🥇',
  silver: '🥈',
  bronze: '🥉',
};
